declare const templateBaseUrl: string;

const showSuccessOrErrorMessage = (success: boolean, message: string) => {
  const messageContainerParent = document.querySelector(
    "[data-ref=formitable-newsletter-message]",
  );

  if (messageContainerParent) {
    messageContainerParent.innerHTML = "";

    const messageContainer = document.createElement("div");
    messageContainer.classList.add(
      success ? "text-success" : "text-danger",
      "mt-4",
    );
    messageContainer.innerHTML = message;
    messageContainerParent.appendChild(messageContainer);
  }
};

export const initializeFormitableNewsletter = () => {
  const inputField = document.querySelector<HTMLInputElement>(
    "[data-ref=formitable-newsletter-signup]",
  );
  const button = document.querySelector<HTMLButtonElement>(
    "[data-ref=formitable-newsletter-button]",
  );

  if (inputField && button) {
    const sendFormitableSignup = () => {
      if (inputField.value && inputField.value.includes("@")) {
        window
          .fetch(`${templateBaseUrl}/formitable_newsletter.php`, {
            method: "POST",
            body: JSON.stringify({
              email: inputField.value,
            }),
          })
          .then((res) => {
            switch (res.status) {
              case 200:
              case 204:
                inputField.disabled = true;
                button.disabled = true;

                showSuccessOrErrorMessage(
                  true,
                  "<strong>Das hat geklappt!</strong> Bitte bestätige deine Anmeldung, indem du den Link in der Mail klickst, die du gleich erhalten wirst.",
                );
                inputField.classList.remove("is-invalid");
                break;
              default:
                showSuccessOrErrorMessage(
                  false,
                  "Da scheint es ein Problem mit der Anmeldung zu geben - bitte probiere es später nochmal.",
                );
                inputField.classList.add("is-invalid");
                break;
            }
          });
      } else {
        showSuccessOrErrorMessage(
          false,
          "Bitte gib eine gültige E-Mail-Adresse ein.",
        );
        inputField.classList.add("is-invalid");
      }
    };

    button.addEventListener("click", sendFormitableSignup);
  }
};
